import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/RegisterPage.css';

const RegisterPage = () => {
  const [staffID, setStaffID] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();

  const handleRegister = () => {
    // Validate the input fields
    if (staffID && username && password && password === confirmPassword) {
      // Save the user's information (e.g., to a database)
      console.log('Registering user:', { staffID, username, password });
      // Redirect to the login page
      navigate('/login');
    } else {
      alert('Please fill in all the required fields correctly.');
    }
  };

  return (
    <div className="register-container">
      <h1 className="register-title">Register</h1>
      <div className="register-form">
        <input
          type="text"
          className="register-input"
          placeholder="Staff ID"
          value={staffID}
          onChange={(e) => setStaffID(e.target.value)}
        />
        <input
          type="text"
          className="register-input"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          className="register-input"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <input
          type="password"
          className="register-input"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        <button className="register-button" onClick={handleRegister}>
          Sign Up
        </button>
        <div className="login-link">
          Already have an account? <a href="/login">Log in</a>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;